/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TimecodeInputs */

const en_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode`)
};

const fr_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code temporel`)
};

const de_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcode`)
};

const it_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale`)
};

const ru_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Временной код`)
};

const es_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tiempo`)
};

const zh_cn2_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码`)
};

const ja_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード`)
};

const hi_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड`)
};

const pt_pt2_timecode = /** @type {(inputs: TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo`)
};

/**
* | output |
* | --- |
* | "Timecode" |
*
* @param {TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode = /** @type {((inputs?: TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode(inputs)
	if (locale === "de") return de_timecode(inputs)
	if (locale === "it") return it_timecode(inputs)
	if (locale === "ru") return ru_timecode(inputs)
	if (locale === "es") return es_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode(inputs)
	if (locale === "ja") return ja_timecode(inputs)
	if (locale === "hi") return hi_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode(inputs)
	return en_timecode(inputs)
});